import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { EditService } from '../../../../services/index';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { HVAddEditComponent } from './addedithv.component';
import { $ } from 'protractor';
@Component({
    selector: 'edit-tab',
    templateUrl: './hvedit.component.html',
})
export class HVEditComponent implements OnInit {
    columns: any[];
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    edithvdata: any;
    totcount: number;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date()
    };
    page = {
        limit: 25,
        count: 0,
        offset: 0,
    };
    loadingIndicator: boolean = true;
    isLoadMask: Promise<any>;
    constructor(public editservice: EditService, private modalService: BsModalService) {

    }
    ngOnInit() {
        this.columns = [
            { name: 'Branch', prop: 'branch', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Client Name', prop: 'name', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Phone', prop: 'mobile', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Appointment Date', prop: 'apdate', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Hv/Hv Retrail', prop: 'lstatus', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Compination', prop: 'compination', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Travel Expence', prop: 'travel_expense', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Outstatus', prop: 'ostatus', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'sno', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];
        this.getHvList();
        this.pageCallback({ offset: 0 });

    }
    applyFilter() {
        this.getHvList();
        this.filterPanel.close();

    }
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getHvList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getHvList();
    }
    getHvList() {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            from_date: moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date: moment(this.filterData['to_date']).format('YYYY-MM-DD'),
        };
        let that = this;
        this.isLoadMask = this.editservice
            .gethveditlist(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                that.edithvdata = res.data;
                that.page.count = res.totCnt;
            });
    }
    bsModalRef: BsModalRef;
    edithventry(mode, row) {
        this.bsModalRef = this.modalService.show(HVAddEditComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-80'
        });
        this.bsModalRef.content.editHvData = Object.assign({}, row);
        this.bsModalRef.content.hvDataLoadEvent.subscribe(($e)=>{
            this.getHvList();
        })

    }

}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/Edit/hvedit/hvedit.component.ts